import React, { FC } from 'react';

interface LogoProps {
  width: number;
  height: number;
  colorOne: string;
  colorTwo: string;
}

const Logo: FC<LogoProps> = ({ width, height, colorOne, colorTwo }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 302.13 370.2"
      width={width}
      height={height}
    >
      <path
        fill={colorOne}
        d="m172.97,90.82c-.99-90.82,1.03,150.49-.99-90.82h-39c-.22,172.02,0,0-.8,89.95-47.24,33.91,2.93,95.34,43.82,64.64,21.36-16.04,20.75-50.38-3.04-63.78Zm-48.97,33.23c0-7.77,3.06-14.82,8.02-20.05-9.86,16.11,1.83,43,20.37,49.17-15.75-.41-28.39-13.28-28.39-29.13Z"
      />
      <path
        fill={colorTwo}
        d="m258.54,179.45c31-90.08,22.5-134.99-72.14-162.96v60.8c41.91,30.59,17.63,103.6-35.27,101.7-55.86,1.12-77.88-75.67-31.2-104.64V15.63C18.84,43.27,14.78,86.13,42.48,180.31c-208.11,254.56,427.12,252.08,216.06-.87Zm-108.09,101.06c-29.67-.18-53.57-19.56-48.87-43.87,7.73,41.45,90.01,41.42,97.73,0,4.7,24.31-19.19,43.69-48.87,43.87Z"
      />
    </svg>
  );
};

const EventListingLogo: FC = () => {
  return <Logo width={30} height={37} colorOne="#81c3d7" colorTwo="#be5965" />;
};

const SmallLogo: FC = () => {
  return <Logo width={25} height={30} colorOne="#81c3d7" colorTwo="#be5965" />;
};

const FooterLogo: FC = () => {
  return <Logo width={41} height={50} colorOne="#06b6d4" colorTwo="#f87171" />;
};
const AvatarLogo: FC = () => {
  return (
    <div className="flex w-7 h-7 justify-center items-center">
      <div className="flex justify-center items-center rounded-full bg-base-100 hover:bg-neutral ring ring-accent/40 hover:ring-accent/60 w-full h-full">
        <Logo width={18} height={23} colorOne="#81c3d7" colorTwo="#be5965" />
      </div>
    </div>
  );
};
// Shopping Cart page logo
const GiantLogo: FC = () => {
  return (
    <Logo width={180} height={222} colorOne="#81c3d7" colorTwo="#be5965" />
  );
};
export { Logo, EventListingLogo, SmallLogo, GiantLogo, FooterLogo, AvatarLogo };
